module.exports = "/_next/static/images/Hero-01e70b3853a27299119a4829cbbd6d98.webp";